module.exports = __webpack_public_path__ + "static/img/ygbj2.f7d03c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ygbj2.png
// module id = xHQs
// module chunks = 0